export default __webpack_public_path__ + "static/media/down_chevron_black.4f39c6c4.svg";